// O upload da imagem do rébus: checagem local, subida e tradução dos erros do
// servidor para mensagem de gente.
//
// A checagem local é ECONOMIA, não autoridade — quem decide é o servidor; ela só
// evita gastar a subida de um arquivo que já se sabe que vai voltar recusado.

import { uploadRebusImagem } from '../../../../../services/admin';

/** Mesmo teto do servidor (e do precedente da foto de perfil). */
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

/** Mesma whitelist do servidor. Serve também para o `accept` do input. */
export const ACCEPTED_MIME = ['image/jpeg', 'image/png', 'image/webp'];

const FORMATO_INVALIDO = 'Formato não aceito. Use JPEG, PNG ou WebP.';
const GRANDE_DEMAIS = 'Imagem maior que 5 MB. Escolha um arquivo menor.';

/** A mensagem do problema, ou `null` se o arquivo passa na checagem local. */
export function checkImage(file: File): string | null {
  if (file.size === 0) return 'Arquivo vazio. Escolha outra imagem.';
  if (!ACCEPTED_MIME.includes(file.type)) return FORMATO_INVALIDO;
  if (file.size > MAX_IMAGE_BYTES) return GRANDE_DEMAIS;
  return null;
}

function status(err: unknown): number | undefined {
  return (err as { response?: { status?: number } })?.response?.status;
}

function serverMsg(err: unknown): string | undefined {
  return (err as { response?: { data?: { msg?: string } } })?.response?.data?.msg;
}

/**
 * Sobe a imagem e devolve a URL pública. Lança `Error` com mensagem pronta para a
 * tela.
 *
 * ⚠️ Os erros do servidor NÃO são todos 400: arquivo grande demais volta **413**,
 * porque o `FileInterceptor` do Nest mapeia `LIMIT_FILE_SIZE` para
 * `PayloadTooLargeException` antes de o service rodar (o precedente da foto de perfil
 * já se comporta assim). MIME inválido e arquivo ausente é que são **400**. As duas
 * mensagens precisam ser diferentes — "formato não aceito" para um PNG legítimo que
 * só era grande demais manda o admin converter o arquivo à toa.
 */
export async function uploadImage(
  idJogo: number,
  file: File,
  onProgress?: (percent: number) => void,
): Promise<string> {
  const local = checkImage(file);
  if (local) throw new Error(local);

  try {
    const { url } = await uploadRebusImagem(idJogo, file, onProgress);
    return url;
  } catch (err: unknown) {
    if (status(err) === 413) throw new Error(GRANDE_DEMAIS);
    if (status(err) === 400) throw new Error(FORMATO_INVALIDO);
    const msg = serverMsg(err);
    throw new Error(msg ?? 'Falha ao subir a imagem. Tente de novo.');
  }
}
